import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {ProductPipe} from "./product-pipe.pipe";

@Pipe({
    name: 'highlight',
    standalone: false
})

export class HighlightSearchPipe implements PipeTransform {

    transform(value: any, args: any): any {
        if (!args || args == '*') {return value;}
        args = args.replace(/^\*\ ./, "");
        if(args.substr(0, 1) == '"' && args.substr(-1) == '"'){
            args = args.substr(1, args.length - 2);
        } else {
            args = args.replace(" ", "|");
        }
        var re = new RegExp(args, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
        return value.replace(re, "<mark class='bg-highlight'>$&</mark>");
    }
}

@NgModule({
    declarations: [HighlightSearchPipe],
    exports: [HighlightSearchPipe]
})
export class HighlightSearchPipeModule {}
